import { render, staticRenderFns } from "./zinnegtiCopy.vue?vue&type=template&id=648dd691&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./zinnegtiCopy.vue?vue&type=script&lang=js"
export * from "./zinnegtiCopy.vue?vue&type=script&lang=js"
import style0 from "./zinnegtiCopy.vue?vue&type=style&index=0&id=648dd691&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648dd691",
  null
  
)

export default component.exports